import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AssociateAuthCheck = ({ children }) => {
  const { userToken, userRole } = useSelector((state) => state.user);

  if (!userToken || userRole !== "ASSOCIATE") {
    return <Navigate to="/associate/signin" replace />;
  }

  return <>{children}</>;
};

export default AssociateAuthCheck;
